import { call, takeLatest } from '@redux-saga/core/effects'
import { put, select } from 'redux-saga/effects'
import { getSelectedItem } from '../selectors'
import { IItem } from '../store/timeline.types'
import { TimelineConstants } from '../store/timeline.constants'
import { getPcrIdSelector } from '../../home/selectors'
import { IPcr } from '../../pcr/store/pcr.types'
import { getServiceIdSelector } from '../../user/selectors'
import { PcrDocsService } from '../../../services/pcrDocs.service'
import { throwPcrException } from '../../pcr/store/pcr.actions'
import { performWithMutexHOG } from '../../../services/mutexUtility.service'
import { setState } from '../../procedures/bloodProductAdministration/store/bloodProductAdministration.actions'

export function* setBloodProductAdministrationProcedureItem() {
  const selectedItem: IItem = yield select(getSelectedItem)
  const pcrID: string = yield select(getPcrIdSelector)
  const serviceId: string = yield select(getServiceIdSelector)
  if (pcrID) {
    try {
      if (selectedItem) {
        const pcrDocsService = new PcrDocsService(serviceId)
        const pcrDoc: IPcr = yield call([pcrDocsService, pcrDocsService.getPCR], pcrID)
        const isState = pcrDoc.patient.bloodProductAdministrationStateList?.find((state) => {
          return state.key === selectedItem.key
        })

        if (isState) {
          const updatedState = {
            ...isState,
            ...(selectedItem.labelHeader ? { time: selectedItem.labelHeader } : {}),
          }
          yield put(setState(updatedState))
        } else {
          yield put(setState(isState))
        }
      }
    } catch (e) {
      yield put(throwPcrException(`setBloodProductAdministrationProcedureItem() error: ${e}`))
    }
  } else {
    // todo: add to audit log
  }
}

export function* setBloodProductAdministrationProcedureItemSaga() {
  yield takeLatest(
    [TimelineConstants.SET_BLOOD_PRODUCT_ADMINISTRATION],
    performWithMutexHOG,
    setBloodProductAdministrationProcedureItem
  )
}
